<template>
    <div class="w-full">
        <div class="lg:flex mb-5">
            <div class="w-full lg:w-1/3 h-auto relative">
                <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest w-full" id="inline-full-name" type="text" placeholder="Type to search for a video" v-model="searchQuery">
                <div class="absolute top-0 right-0 pr-3 pt-2">
                    <i class="fa fa-circle-notch fa-spin" v-if="searching"></i>
                </div>
            </div>
            <div class="flex w-full lg:w-2/3 text-right items-center">
                <Dropdown class="ml-auto mt-5 lg:mt-0">
                    <template #trigger="{ hasFocus, isOpen }">
                        <div class="px-2 py-1 text-white rounded" :class="[(hasFocus || isOpen) ? 'bg-blue-500' : 'bg-blue-700']">
                            <i class="fas fa-filter"></i>
                        </div>
                    </template>
                    <template #dropdown>
                        <div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl text-left">
                            <a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': orderByStatus == 'desc', 'text-gray-800': orderByStatus !== 'desc'}" @click="orderBy('desc')">Newest first</a>
                            <a href="#" class="block hover:text-white mt-0 px-4 py-2 hover:bg-blue-500" :class="{'bg-blue-500 text-white': orderByStatus == 'asc', 'text-gray-800': orderByStatus !== 'asc'}" @click="orderBy('asc')">Oldest first</a>
                        </div>
                    </template>
                </Dropdown>
            </div>
        </div>

        <CustomTable class="bg-white rounded shadow-md group">
            <template v-slot:header>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Price</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Thumbnail</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video Details</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Locations</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Time Ago</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
            </template>
            <template v-slot:body>
                <tr class="hover:bg-grey-lighter" v-for="video in videos">
                    <td class="py-4 px-6 border-b border-grey-light">
                        <h2 class="text-xl mb-0">${{ video.price }}</h2>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light w-48">
                        <progressive-img class="video-thumbnail" fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" />
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <div class="video-details">
                            <strong>{{ video.title }}</strong> <br/>
                            {{ video.created_at | displayLocalDateTime}} <br/>
                            Duration: {{ video.length | timecode }} <br/>
                            Credit: {{ video.user_credit }} / Viral News <br/>
                            <strong class="text-red-600" v-if="video.embargo !== null">Embargo: {{ video.embargo }}</strong>
                        </div>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <span class="px-2 py-1 bg-green-600 text-white rounded mr-2 inline-block text-xs my-1" v-for="location in video.locations">{{ location }}</span>
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        {{ video.created_at | timeAgo }}
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <button class="px-2 py-1 bg-blue-700 text-white rounded mr-2 inline-block text-sm my-1 focus:outline-none" v-on:click="viewVideoModal(video)">View Video</button>
                    </td>
                </tr>
                <tr class="bg-grey-lighter text-center" v-if="videos.length == 0">
                    <td class="py-5" colspan="7">
                        No videos were found for this query. Try broadening your search query.
                    </td>
                </tr>
                <infinite-loading @infinite="infiniteHandler" style="opacity: 0; height: 0;">
                    <span slot="no-more"></span>
                </infinite-loading>
            </template>
        </CustomTable>
        <view-video-modal></view-video-modal>
    </div>
			
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import ViewVideoModal from './modals/ViewVideoModal'
    import CustomTable from '@/components/general/CustomTable'
    import Dropdown from '@/components/partials/Dropdown'
    import InfiniteLoading from 'vue-infinite-loading'

	export default {
		name: 'MediaLatestUploaded',
		data () {
			return {
                options: this.getAuthorizationHeader(),
                videos: [],
                resource_url: Config.apiPath + "/api/v2/media/search/videos",

                userCollection: null,
                searchTerms: null,
                user: null,
                loading: false,
                hasSearched: false,

                searchQuery: '',
                current_page: 1,
                last_page: null,
                searching: false,
                searchDebounce: null,
                orderByStatus: null,
			}
        },
        components: {
            'view-video-modal': ViewVideoModal,
            CustomTable,
            Dropdown,
            InfiniteLoading
		},
        mounted() {
            this.$nextTick(function () {
                EventBus.$on('media-video-refresh-data', this.getVideos);
            }.bind(this));
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            
            updateResource(data){
                this.videos = data;
            },

            downloadVideo(id) {
                this.$http.get(Config.apiPath + "/api/v2/admin/videos/" + id + "/download", this.getAuthorizationHeader())
                    .then(response => {
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = response.data;
                        link.click();
                        document.body.removeChild(link);
                    });
            },

            editVideo(video) {
                console.log('clicked')
                EventBus.$emit('admin-edit-video-open-modal', video);
            },

            infiniteHandler($state) {

                var _this = this;

                if(this.last_page !== null) {
                    if((this.current_page - 1) == this.last_page) return
                }

                this.$http.get(this.computeResourceUrl(), this.getAuthorizationHeader()).then((response) => {

                    _this.current_page = response.data.current_page + 1;
                    _this.last_page = response.data.last_page

                    var data = response.data.data;

                    const temp = [];
                    for (var i = 0; i < data.length; i++) {
                        temp.push(data[i]);
                    }
                    _this.videos = _this.videos.concat(temp);

                    $state.loaded();

                });

            },

            search() {
                this.current_page = 1
                this.videos = []

                var _this = this

                this.$http.get(this.computeResourceUrl(), this.getAuthorizationHeader()).then((response) => {
                    _this.current_page = response.data.current_page + 1;
                    var data = response.data.data;
                    _this.videos = data
                    _this.searching = false
                });
            },

            orderBy(value) {
                this.orderByStatus = value
                this.search()
            },

            computeResourceUrl() {
                var baseURL = this.resource_url + "?page=" + (this.current_page)

                if(this.searchQuery !== '') {
                    baseURL += "&search=" + this.searchQuery
                }

                if(this.orderByStatus !== null) {
                    baseURL += "&orderBy=" + this.orderByStatus
                }

                return baseURL
            },
            viewVideoModal(video) {
                EventBus.$emit('media-view-video-open-modal', video);
            }
        },
        watch: {
            searchQuery: function() {
                this.searching = true
                clearTimeout(this.searchDebounce)
                this.searchDebounce = setTimeout(() => {
                    this.search()
                }, 600)
            }
        },
        filters: {
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm:ss a');
            }
        }
	}
</script>